import { CFADrawerKey, DrawerConfigValues } from '../model';

/** Addition type for Add CFA drawer: CFA or Fulfilment Location (Godown) */
export const CFA_ADDITION_TYPE = {
  CFA: 'CFA',
  FULFILMENT_LOCATION: 'Fulfilment Location',
} as const;

export const CFADrawerConfig: Record<CFADrawerKey, DrawerConfigValues> = {
  details: {
    tabName: 'Details',
    sections: [
      {
        sectionName: 'Details',
        sectionId: 'details',
        isCustomSection: true,
        blocks: [
          {
            inputs: [
              {
                inputType: 'dropdownInput',
                label: 'Type',
                name: 'additionType',
                required: true,
                placeholder: 'Select',
              },
            ],
          },
          {
            inputs: [
              {
                inputType: 'textInput',
                label: 'Name',
                name: 'name',
                required: true,
                placeholder: 'Enter',
              },
            ],
          },
          {
            inputs: [
              {
                inputType: 'textInput',
                label: 'Code',
                name: 'code',
                required: true,
                placeholder: 'Enter',
              },
              {
                inputType: 'textInput',
                label: 'Mobile Number',
                name: 'phone',
                required: true,
                placeholder: 'Enter',
                prefixValue: '+91',
                maxLength: 10,
              },
            ],
          },
          {
            inputs: [
              {
                inputType: 'textInput',
                label: 'GST Number',
                name: 'gstNumber',
                required: false,
                placeholder: 'Enter GST Number',
                maxLength: 15,
                inputValueType: 'alphanumeric',
                // validation: {
                //   pattern: /^[0-9A-Z]{15}$/,
                //   errorMessage: 'Enter a valid 15-digit GST Number',
                // },
              },
            ],
          },
          {
            inputs: [
              {
                inputType: 'textInput',
                label: 'Email',
                name: 'email',
                required: true,
                placeholder: 'Enter',
                inputValueType: 'email',
              },
            ],
          },
          {
            inputs: [
              {
                inputType: 'textInput',
                label: 'City',
                name: 'city',
                required: true,
                placeholder: 'Enter',
              },
              {
                inputType: 'dropdownInput',
                label: 'State',
                name: 'state',
                required: true,
                placeholder: 'Select',
              },
            ],
          },
          {
            inputs: [
              {
                inputType: 'textInput',
                label: 'Pin Code',
                name: 'pin',
                required: true,
                placeholder: 'Enter',
                inputValueType: 'postalCode',
              },
              {
                inputType: 'textInput',
                label: 'Country',
                name: 'country',
                required: true,
                placeholder: 'Select',
              },
            ],
          },
          {
            inputs: [
              {
                inputType: 'textInput',
                label: 'Physical Address',
                name: 'physicalAddress',
                required: false,
                placeholder: 'Enter Physical Address',
              },
            ],
          },
        ],
      },
      {
        sectionName: 'Price List',
        sectionId: 'priceList',
        isCustomSection: true,
      },
    ],
  },
  // customers: {
  //   tabName: 'Customers',
  //   sections: [
  //     {
  //       sectionName: '',
  //       blocks: [],
  //     },
  //   ],
  // },
};
